export default __webpack_public_path__ + "static/media/nc_student.695953b4.png";